import React, { useEffect } from 'react'
import { Link, Navigate } from "react-router-dom";
import DrawerComponent from "../../Drawer";
import { useState } from 'react';

export const PaginaReporte = (props) => {
    const { children, Titulo } = props;
    const [shouldRedirect, setShouldRedirect] = useState(false);

    React.useEffect(() => {
        if (!localStorage.getItem("Estilo")) return;

        const existing = document.getElementById('theme-link');
        if (existing) {
            existing.href = localStorage.getItem("Estilo");
            return;
        }

        const link = document.createElement('link');
        link.id = 'theme-link';
        link.rel = 'stylesheet';
        link.href = localStorage.getItem("Estilo");
        document.head.appendChild(link);

        return () => {
            const el = document.getElementById('theme-link');
            if (el) document.head.removeChild(el);
        };
    }, [localStorage.getItem("Estilo")]);

    useEffect(() => {
        const user = localStorage.getItem("user");
        const codigoCompania = localStorage.getItem("CodigoCompania");
        const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
        const codigoPlanta = localStorage.getItem("CodigoPlanta");
        const idPersona = localStorage.getItem("IdPersona");

        // Verificar valores en localStorage
        if (!user || user === "null" || user === "undefined" || user.trim() === "" ||
            !codigoCompania || codigoCompania === "null" || codigoCompania === "undefined" || codigoCompania.trim() === "" ||
            !codigoEmpresa || codigoEmpresa === "null" || codigoEmpresa === "undefined" || codigoEmpresa.trim() === "" ||
            !codigoPlanta || codigoPlanta === "null" || codigoPlanta === "undefined" || codigoPlanta.trim() === "" ||
            !idPersona || isNaN(Number(idPersona)) || Number(idPersona) < 1) {
                
            if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
            } else {
                setShouldRedirect(true);
            }
        }
    }, []);

    if (shouldRedirect) {
        return <Navigate to="/Login" />;
    }

    return (
        <div id="DC" style={{ height: "97vh", flexGrow: 1, overflow: "auto" }}>
            <DrawerComponent
                IdPersona={localStorage.getItem("IdPersona")} />
            <div style={{ marginTop: "75px", marginLeft: "20px", height: "20px", overflow: "hidden" }}>
                {Titulo && (
                    <span className="fas fa-table" style={{ fontSize: "12px", margin: "0px", padding: "0px" }}> {Titulo} </span>
                )}
            </div>

            {/* Contenido escalado con zoom (no afecta scroll) */}
            <div style={{ margin: "10px", zoom: 0.80 }}>
                {children}
            </div>
        </div>
    );
}